export enum FreeReadingTypeEnum {
  DAILY_LIMIT = 'DAILY_LIMIT',
  PERIOD_SPECIFIC = 'PERIOD_SPECIFIC',
  DURATION_SPECIFIC = 'DURATION_SPECIFIC',
}

export const freeReadingTypeLabel: Record<FreeReadingTypeEnum, string> = {
  [FreeReadingTypeEnum.DAILY_LIMIT]: 'ฟรีวันละ x ตอน',
  [FreeReadingTypeEnum.PERIOD_SPECIFIC]: 'ฟรี x วัน',
  [FreeReadingTypeEnum.DURATION_SPECIFIC]: 'ฟรีช่วงเวลา',
}
